﻿import { useMemo } from "react";

type StartResolutionModalProps = {
  open: boolean;
  beschlussnummer: string;
  enddatum: string;
  error?: string;
  isPending?: boolean;
  onClose: () => void;
  onEnddatumChange: (value: string) => void;
  onConfirm: () => void;
};

const getMinEndDateKey = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export const StartResolutionModal = ({
  open,
  beschlussnummer,
  enddatum,
  error,
  isPending,
  onClose,
  onEnddatumChange,
  onConfirm
}: StartResolutionModalProps) => {
  const minDate = useMemo(() => getMinEndDateKey(), []);

  if (!open) return null;

  return (
    <div className="modal-backdrop">
      <section className="panel modal-card start-resolution-modal" role="dialog" aria-modal="true" aria-labelledby="start-resolution-title">
        <div className="start-resolution-modal-head">
          <span className="start-resolution-modal-head-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
              <path d="M7.5 3.8v3M16.5 3.8v3M3.6 9h16.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              <circle cx="8.3" cy="12.6" r="1.1" fill="currentColor" />
              <circle cx="12" cy="12.6" r="1.1" fill="currentColor" />
              <circle cx="15.7" cy="12.6" r="1.1" fill="currentColor" />
            </svg>
          </span>
          <div className="start-resolution-modal-head-copy">
            <h3 id="start-resolution-title">Beschluss manuell starten</h3>
            <p>
              Für Beschluss <strong>{beschlussnummer}</strong> ist kein Enddatum gesetzt.
              Bitte Enddatum auswählen, bevor gestartet wird.
            </p>
          </div>
        </div>

        <div className="form-field start-resolution-modal-field">
          <label>Enddatum*</label>
          <div className="start-resolution-modal-date-wrap">
            <input
              className="table-field start-resolution-modal-date-input"
              type="date"
              min={minDate}
              value={enddatum}
              onChange={(e) => onEnddatumChange(e.target.value)}
            />
            <span className="start-resolution-modal-date-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <rect x="4.5" y="6.5" width="15" height="13" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
                <path d="M8 4.5v3M16 4.5v3M4.8 10h14.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              </svg>
            </span>
          </div>
        </div>

        {error ? <div className="error-text start-resolution-modal-error">{error}</div> : null}

        <div className="form-actions start-resolution-modal-actions">
          <button type="button" className="start-resolution-modal-cancel-btn" onClick={onClose} disabled={isPending}>
            <span className="start-resolution-modal-btn-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </span>
            Abbrechen
          </button>
          <button type="button" className="start-resolution-modal-submit-btn" onClick={onConfirm} disabled={isPending}>
            <span className="start-resolution-modal-btn-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M7 5.8v12.4L18 12 7 5.8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
              </svg>
            </span>
            {isPending ? "Starte..." : "Starten"}
          </button>
        </div>
      </section>
    </div>
  );
};
